import { gql } from '@apollo/client';

const UPDATE_STUDENT_ASSESSMENT_OUTCOME = gql`
  mutation UpdateStudentAssessmentOutcome(
    $where: StudentAssessmentOutcomeWhereInput!
    $data: StudentAssessmentOutcomeUpdateInput!
  ) {
    updateStudentAssessmentOutcome(where: $where, data: $data) {
      id
    }
  }
`;

export default UPDATE_STUDENT_ASSESSMENT_OUTCOME;
